import { useState } from 'react';
import {
  CardContent,
  IconButton,
  Link,
  Menu,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { ManualApplicationEntity } from '@shared/api';
import { DateUtils, RoutePaths, useRouteHook } from '@shared';

const COLUMNS_COUNT = 5;

interface Props {
  loading: boolean;
  data: ManualApplicationEntity[];
}

export const ManualApplicationsTable = (props: Props) => {
  const [page, setPage] = useState<number>(0);
  const [rowsPerPage, setRowsPerPage] = useState<number>(10);
  const [cardAnchors, setCardAnchors] = useState<Array<Element | null>>(props.data.map(() => null)); // Card Anchors to sort menu item index issue

  const { navigate } = useRouteHook();

  // Open Card Menu Item
  const handleClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>, idx: number) => {
    setCardAnchors((curAnchors) => {
      const anchors = curAnchors.slice();
      anchors.splice(idx, 1, e.currentTarget);
      return anchors;
    });
  };

  // Close Card Menu Item
  const handleClose = (idx: number) => {
    setCardAnchors((curAnchors) => {
      const anchors = curAnchors.slice();
      anchors.splice(idx, 1, null);
      return anchors;
    });
  };

  const routeToManualApplication = (manualAppId: string, partnerUserId: string) =>
    navigate(RoutePaths.manualApplicationsDetails.onNavigate(manualAppId), { state: { partnerUserId } });

  if (props.loading) {
    return (
      <CardContent style={{ textAlign: 'center' }}>
        <Typography variant='body1'>Loading application details</Typography>
      </CardContent>
    );
  }
  if (!props.data) {
    return (
      <CardContent style={{ textAlign: 'center' }}>
        <Typography align='center'>
          No data to display.
          <br />
          Start by performing a search.
        </Typography>
      </CardContent>
    );
  }
  return (
    <>
      <Table aria-label='simple table' stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell>Reference</TableCell>
            <TableCell style={{ width: '200px' }} align='center'>
              Partner
            </TableCell>
            <TableCell style={{ width: '200px' }} align='center'>
              Status
            </TableCell>
            <TableCell style={{ width: '200px' }} align='center'>
              Last Updated
            </TableCell>
            <TableCell style={{ width: '100px' }} align='center'>
              Actions
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, idx) => (
            <TableRow key={row.manualAppId} hover>
              <TableCell component='th' scope='row'>
                <Link onClick={() => routeToManualApplication(row.manualAppId, row.userId)} color='primary' style={{ cursor: 'pointer' }}>
                  {row.manRefId || row.manualAppId}
                </Link>
                <br />
              </TableCell>
              <TableCell align='center'>
                {row.partnerName}
                {/*{partners.length > 1 && 'Pending partner id in API'}
                    {partners.length === 1 && partners[0].name}*/}
              </TableCell>
              <TableCell align='center'>{row.status}</TableCell>
              <TableCell align='center'>{DateUtils.formatDate(row.lastUpdated)}</TableCell>
              <TableCell align='center'>
                <IconButton onClick={(e) => handleClick(e, idx)} size='large'>
                  <MoreVertIcon />
                </IconButton>
                <Menu anchorEl={cardAnchors[idx]} open={Boolean(cardAnchors[idx])} onClick={() => handleClose(idx)}>
                  <MenuItem onClick={() => routeToManualApplication(row.manualAppId, row.userId)}>View</MenuItem>
                </Menu>
              </TableCell>
            </TableRow>
          ))}
          {!props.data.length ? (
            <TableRow>
              <TableCell colSpan={COLUMNS_COUNT} align='center'>
                No Records Found
              </TableCell>
            </TableRow>
          ) : null}
        </TableBody>
      </Table>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component='div'
        count={props.data.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={(_, value) => setPage(value)}
        onRowsPerPageChange={(e) => {
          setPage(0);
          setRowsPerPage(+e.target.value);
        }}
      />
    </>
  );
};
